import React from "react";

import LogoNotificacao from "../../images/logo-notificacoes.png";
// import Filter from "../../images/filter.png";
import { DashboardModel } from "./dashboardServicos.model.js";

import { FaCircle, FaRegShareSquare } from "react-icons/fa";

import Writin from "../../images/writing.png";
import Return from "../../images/return.png";
import Correct from "../../images/correct.png";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { BaSeIcon, BaSeLoadingPage } from "@base/react";
import "./style.scss";

const colorsStatus = {
  OK: "#33CC66",
  NOT_FOUND: "#FF0000",
  INSTAVEL: "#FFCC01",
  INDISPONIVEL: "#262424",
};


const columns = [
  {
    id: "nome",
    label: "Nome do servico",
    minWidth: 20,
  },
  {
    id: "parceiro",
    label: "Parceiro",
    minWidth: 50,
    align: "left",
  },
  {
    id: "menu",
    label: "Menu",
    minWidth: 50,
    align: "left",
  },
  {
    id: "responseTime",
    label: "Tempo de Resposta (Segundos)",
    minWidth: 50,
    align: "center",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 50,
    align: "center",
  },
  {
    id: "url",
    label: "Link",
    minWidth: 50,
    align: "center",
  },
];

export const DashboardServicos = () => {
  const {
    filters,
    isLoading,
    filterMode,
    setFilterMode,
    data,
    updateCheck,
    updateFilters,
    updateOrder,
    staticData,
    order,
  } = DashboardModel();

  // const showFilter = () => setFilterMode(true);
  const closeFilter = () => setFilterMode(false);


  const renderFilterMode = () => (
      <div>
        <div className="container-principal">
          <div className="filtro-container">
            <div className="modal-flex-direction-row">
              <img alt="imagem" className="writin" src={Writin}/>
              <h2 className="text-color-branco-titulo">Serviços: filtros</h2>
              <div className="div-acoes-carrossel">
                <div
                    onClick={() => updateCheck()}
                    className="icons-acoes-modal-filtro"
                >
                  <button className="btn-acoes-filtro-header">
                    Ver resultados
                    <img alt="imagem" className="correct-icon" src={Correct}/>
                  </button>
                </div>
                <div className="icons-acoes-modal-filtro">
                  <img
                      onClick={closeFilter}
                      alt="imagem"
                      className="writin"
                      src={Return}
                  />
                  <p className="text-color-branco">Voltar</p>
                </div>
              </div>
            </div>
          </div>
          <hr size="1" className="separador-servicos"></hr>
          <div className="filtro-content">
            <div className="div-tabelas-carrossel-filtro">
              <p className="text-color-branco-campo">Ordenar por:</p>
              <div className="div-acoes-filtro">
                <div
                    onClick={() => updateOrder("titulo", 0)}
                    className="icons-acoes-filtros"
                >
                  <button
                      className={
                        order?.titulo?.["0"]
                            ? "btn-select-filtro"
                            : "btn-acoes-filtro"
                      }
                  >
                    Titulo
                  </button>
                </div>
              </div>
            </div>
            <div className="div-tabelas-carrossel-filtro">
              <p className="text-color-branco-campo">Menu:</p>
              <div className="div-acoes-filtro">
                {staticData
                    .filter(
                        (v, i, a) => a.findIndex((t) => t.menu === v.menu) === i
                    ) //removing duplicates
                    .map((each, index) => (
                        <div
                            onClick={() => updateFilters("menu", each.menu)}
                            className="icons-acoes-filtros"
                        >
                          <button
                              className={
                                filters?.menu?.[each.menu]
                                    ? "btn-select-filtro"
                                    : "btn-acoes-filtro"
                              }
                          >
                            {each.menu}
                          </button>
                        </div>
                    ))}
              </div>
            </div>
            <div className="div-tabelas-carrossel-filtro">
              <p className="text-color-branco-campo">Parceiros:</p>
              <div className="div-acoes-filtro">
                {staticData
                    .filter(
                        (v, i, a) =>
                            a.findIndex((t) => t.parceiro === v.parceiro) === i
                    ) //removing duplicates
                    .map((each, index) => (
                        <div
                            onClick={() => updateFilters("parceiro", each.parceiro)}
                            className="icons-acoes-filtros"
                        >
                          <button
                              className={
                                filters?.parceiro?.[each.parceiro]
                                    ? "btn-select-filtro"
                                    : "btn-acoes-filtro"
                              }
                          >
                            {each.parceiro}
                          </button>
                        </div>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
  
  const renderDefault = (value, column, id) => {
    if (!value) return null;
    return (
        <TableCell
            style={{background: "#fff"}}
            key={column.id}
            align={column.align}
        >
          <p className="text-table-servicos">{value} </p>
        </TableCell>
    );
  };
  
  const renderStatus = (value, column) => {
    if (value !== "NOT_FOUND") {
      return (
        <TableCell
          style={{ background: "#fff" }}
          key={column.id}
          align={column.align}
        >
          <FaCircle
            size={30}
            className="text-table-servicos"
            color={colorsStatus[value]}
          >
            16
          </FaCircle>
        </TableCell>
      );
    }
  };
  
  const renderUrlIcon = (value, column) => {
    if (!value) return null;
    return (
        <>
          <TableCell
              style={{background: "#fff"}}
              key={column.id}
              align={column.align}
          >
            <a href={value} target="_blank" rel="noopener noreferrer">
              <FaRegShareSquare
                  size={22}
                  className="url-icon"
              />
            </a>
          </TableCell>
        </>
    );
  };
  
  const listServicos = () => (
      <div className="container-principal">
        <div className="modal-push-servicos">
          <div className="modal-flex-direction-row">
            <img
                alt="imagem"
                className="logo-notificacao"
                src={LogoNotificacao}
            />
            <h2 className="text-color-branco-titulo">Serviços: dashboard</h2>
            <div className="div-acoes-push">
              <div className="icons-acoes-push">
                <BaSeIcon
                    onClick={updateCheck}
                    name="refresh"
                    description="Atualizar checagem"
                    color="#ffffff"
                    size={36}
                >
                  Atualizar
                </BaSeIcon>
                <p className="text-color-branco">Atualizar</p>
              </div>
              {/*<div className="icons-acoes-push">*/}
              {/*  <img*/}
              {/*      onClick={showFilter}*/}
              {/*      alt="imagem"*/}
              {/*      className="sort"*/}
              {/*      src={Filter}*/}
              {/*  />*/}
              {/*  <p className="text-color-branco">Filtros</p>*/}
              {/*</div>*/}
            </div>
          </div>
          <h3>
            Monitoramento da estabilidade dos serviços consumidos pelo App Sebrae
          </h3>
        </div>
        <div>
          <div className="types-status-container">
            <span>{data.length} serviços consumidos pelo APP</span>
            <div className="data-info">
              <div>
                <FaCircle size={16} color={colorsStatus.OK}/>
                <span>Disponíveis</span>
                <span>({data?.filter((dt) => dt?.status === "OK").length ?? 0})</span>
              </div>
              
              <div>
                <FaCircle size={16} color={colorsStatus.INSTAVEL}/>
                <span>Instáveis</span>
                <span>
                ({data?.filter((dt) => dt?.status === "INSTAVEL").length ?? 0})
              </span>
              </div>
              
              <div>
                <FaCircle size={16} color={colorsStatus.INDISPONIVEL}/>
                <span>Indisponíveis</span>
                <span>
                ({data?.filter((dt) => dt?.status === "INDISPONIVEL").length ?? 0})
              </span>
              </div>
              
              {/*<div style={{display: 'flex', flexDirection: 'row'}}>*/}
              {/*  <BaSeIcon*/}
              {/*      color={colorsStatus.NOT_FOUND}*/}
              {/*      description="Não encontrado"*/}
              {/*      name="close"*/}
              {/*      size={16}*/}
              {/*  />*/}
              {/*  <span>Sem URL</span>*/}
              {/*  <span>*/}
              {/*  ({data?.filter((dt) => dt?.status === "NOT_FOUND").length ?? 0})*/}
              {/*</span>*/}
              {/*</div>*/}
            </div>
          </div>
          <div className="table-wrapper">
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                      <TableCell
                          key={column.id}
                          align={column.align}
                          style={{minWidth: column.minWidth}}
                      >
                        <p className="title-table-servicos">{column.label}</p>
                      </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, key) => {
                  if (!row) {
                    return null
                  }
                  return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                        {columns.map((column) => {
                          const {id} = column;
                          const value = row[id];
                          if (id === "status") {
                            return renderStatus(value, column);
                          }
                          if (id === "url") {
                            return renderUrlIcon(value, column);
                          }
                          return renderDefault(value, column, id);
                        })}
                      </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
  );
  
  return (
      <>
        {isLoading && <BaSeLoadingPage/>}
        {!filterMode && !isLoading && listServicos()}
        {filterMode && !isLoading && renderFilterMode()}
      </>
  );
};

export default DashboardServicos;
